export const AUTH_TOKEN = 'auth_token'
export const TIME_STAMP = 'time_stamp'
export const NOTIFICATIONS = 'notifications'
export const UNSEEN_NOTIFICATIONS = 'unseen_notifications'
export const MENU_COUNTERS = 'menu_counters'
export const APPLICATION_MENU_COUNTERS = 'application_menu_counters'
export const PERMISSIONS = 'permissions'
export const ADDRESS = 'address'
export const MEMBER = 'member'
export const ROLE = 'role'